// Arabic message translations
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "تم اختصار هذه الإجابة لأنها وصلت إلى الحد الأقصى للطول وقد تكون غير مكتملة.",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "لا يمكن الإجابة على هذا الطلب وفقًا لإرشادات السلامة. يُرجى إعادة صياغته أو السؤال عن موضوع آخر.",
  // Common UI elements
  Send: "إرسال",
  "Clear chat": "مسح المحادثة",
  Support: "الدعم",
  Settings: "الإعدادات",
  Language: "اللغة",
  Theme: "المظهر",
  "Font Size": "حجم الخط",
  "Select language": "اختر اللغة",

  // Chat interface
  "Type your message...": "اكتب رسالتك...",
  "Thinking...": "جاري التفكير...",
  "Ministry of Commerce Laws Expert": "خبيرة أنظمة وزارة التجارة",
  "by MJ": "بواسطة MJ",
  "Mila": "Mila",

  // Frameworks
  "Automatic detection": "كشف تلقائي",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "أ١. نظام الشركات",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "أ٢. نظام الشركات المهنية",
  "MOC_COMMERCIAL_REGISTER_LAW": "أ٣. نظام السجل التجاري",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "أ٤. نظام وزارة التجارة",
  "MOC_TRADE_NAMES_LAW": "أ٥. نظام الأسماء التجارية",
  "MOC_GCC_TRADEMARK_LAW": "أ٦. نظام العلامات التجارية لدول مجلس التعاون الخليجي",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "ب١. نظام الأوراق التجارية",
  "MOC_COMMERCIAL_PLEDGE_LAW": "ب٢. نظام الرهن التجاري",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "ب٣. نظام ضمان الحقوق بالأموال المنقولة",
  "MOC_INSOLVENCY_LAW": "ب٤. نظام الإفلاس",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "ج١. نظام الوكالات التجارية",
  "MOC_FRANCHISE_LAW": "ج٢. نظام الامتياز التجاري",
  "MOC_ECOMMERCE_LAW": "ج٣. نظام التجارة الإلكترونية",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "ج٤. نظام الغرف التجارية",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "د١. نظام الدفاتر التجارية",
  "MOC_COMMERCIAL_DATA_LAW": "د٢. نظام البيانات التجارية",
  "MOC_PUBLIC_WAREHOUSING_LAW": "د٣. نظام المستودعات العامة",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "هـ١. نظام الهيئة السعودية للمواصفات والمقاييس والجودة",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "هـ٢. نظام القياس والمعايرة",
  "MOC_PRIVATE_LABORATORIES_LAW": "هـ٣. نظام المختبرات الخاصة",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "هـ٤. نظام المعادن الثمينة والأحجار الكريمة",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "هـ٥. نظام إدارة استيراد المواد الكيميائية",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "و١. نظام المحاسبين القانونيين",
  "MOC_VALUERS_LAW": "و٢. نظام المقيمين المعتمدين",
  "MOC_ENGINEERS_LAW": "و٣. نظام مجلس المهندسين السعوديين",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "ز١. نظام مكافحة التستر",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "ز٢. نظام مكافحة غسل الأموال",
  "MOC_ARBITRATION_LAW": "ز٣. نظام التحكيم",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "ز٤. نظام مكافحة الغش التجاري",
  "MOC_GCC_COMBATING_DUMPING_LAW": "ز٥. نظام مكافحة الإغراق لدول مجلس التعاون الخليجي",

  // Models
  "Claude by Anthropic": "كلود من أنثروبيك",
  "DeepSeek by Groq": "ديب سيك من جروك",
  "MJ Lab Mode": "وضع مختبر MJ",

  // Messages
  "Language changed to {locale}": "تم تغيير اللغة إلى {locale}",
  "Hello, I am {{name}}, an AI assistant made by MJ.":
    "مرحبًا، أنا {{name}}، مساعدة ذكاء اصطناعي من تطوير MJ.",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.":
    "أنا خبيرة في قوانين وأنظمة وزارة التجارة في المملكة العربية السعودية.",
  "Ask me a question, and I will gladly answer you.":
    "اسألني سؤالا، وسأجيب عليك بكل سرور.",
  "Do not share confidential data.": "لا تشارك البيانات السرية.",
  "I am powered using": "أنا أعمل باستخدام",

  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.":
    "**إخلاء مسؤولية:** {{name}} هي مساعدة ذكاء اصطناعي تجريبية مصممة للرد باستخدام بيانات من قوانين وأنظمة وزارة التجارة السعودية، مع تجنب الافتراضات أو عدم الدقة. أنا لست مسؤولاً عن سلوكها أو صحة إجاباتها.",

  // Error messages
  "An error occurred": "حدث خطأ",
  "Failed to change language": "فشل تغيير اللغة",
  "Please try again": "يرجى المحاولة مرة أخرى",
  "Connection lost": "انقطع الاتصال",
  "Reconnecting...": "جاري إعادة الاتصال...",
  "Nothing to clear": "لا يوجد شيء للمسح",
  "All messages cleared": "تم مسح جميع الرسائل",
  "All data cleared": "تم مسح جميع البيانات",
  "Storage limit reached": "تم الوصول إلى حد التخزين",
  "Some older messages were removed to save space.":
    "تمت إزالة بعض الرسائل القديمة لتوفير المساحة.",
  Error: "خطأ",

  // Tooltips
  "Increase font size": "زيادة حجم الخط",
  "Decrease font size": "تقليل حجم الخط",
  "Reset font size": "إعادة تعيين حجم الخط",
  "Change theme": "تغيير المظهر",
  "Support the project": "دعم المشروع",

  // Character count
  "{{remainingChars}} character left": "حرف {{remainingChars}} متبقي",
  "{{remainingChars}} characters left": "{{remainingChars}} حرف متبقي",

  // Message actions
  "Message copied to clipboard": "تم نسخ الرسالة إلى الحافظة",
  Read: "قراءة",
  Summarize: "تلخيص",

  // Ice Breakers Dialog
  "Message Suggestions": "اقتراحات الرسائل",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.":
    "اختر سؤالاً لبدء محادثة حول أنظمة وزارة التجارة السعودية.",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?":
    "ما هي المتطلبات الرئيسية بموجب نظام الشركات لتأسيس شركة ذات مسؤولية محدودة في المملكة العربية السعودية؟",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?":
    "كيف ينظم نظام الوكالات التجارية العلاقات بين الشركات الأجنبية والوكلاء السعوديين؟",
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?":
    "ما هي الحماية التي يوفرها نظام التجارة الإلكترونية السعودي للمستهلكين والشركات عبر الإنترنت؟",

  // Audio Player Dialog
  "AI Summary": "ملخص الذكاء الاصطناعي",
  "Listen to the summarized response using our AI Service.":
    "استمع إلى الرد الملخص باستخدام خدمة الذكاء الاصطناعي.",
  "Generating summary...": "جاري إنشاء الملخص...",
  "Preparing audio...": "جاري تحضير الصوت...",

  // Audio Player Error Messages
  "Failed to process text. Please try again.":
    "فشلت معالجة النص. يرجى المحاولة مرة أخرى.",
  "Failed to auto-play audio. Click play to try again.":
    "فشل تشغيل الصوت تلقائيًا. انقر على تشغيل للمحاولة مرة أخرى.",
  "Failed to load audio. Please try again.":
    "فشل تحميل الصوت. يرجى المحاولة مرة أخرى.",
  "Audio playback was aborted.": "تم إلغاء تشغيل الصوت.",
  "Network error occurred while loading audio.":
    "حدث خطأ في الشبكة أثناء تحميل الصوت.",
  "Audio decoding failed.": "فشل فك تشفير الصوت.",
  "Audio format not supported.": "تنسيق الصوت غير مدعوم.",
  "Failed to setup audio playback": "فشل إعداد تشغيل الصوت",
  "Failed to generate speech": "فشل توليد الكلام",
  "Failed to generate audio. Please try again.":
    "فشل إنشاء الصوت. يرجى المحاولة مرة أخرى.",
  "Failed to play audio. Please try again.":
    "فشل تشغيل الصوت. يرجى المحاولة مرة أخرى.",

  // Brand names (do not translate)
  Mila: "Mila",
  
  // Update Notifications
  "update.updateAvailable": "تحديث متاح",
  "update.newVersionAvailable": "الإصدار الجديد {{version}} متاح",
  "update.refreshToApply": "قم بالتحديث لتطبيق أحدث الميزات والتحسينات",
  "update.later": "لاحقًا",
  "update.updateNow": "تحديث الآن"
};
